var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.532,54.024H63.191V41.976h10.341c1.104,0,2-0.896,2-2s-0.896-2-2-2H63.191v-6.471c0-1.104-0.896-2-2-2H48.082 c-6.617,0-12,5.383-12,12V46H22.468c-1.104,0-2,0.896-2,2s0.896,2,2,2h13.614v4.495c0,6.617,5.383,12,12,12h13.109 c1.104,0,2-0.896,2-2v-6.471h10.341c1.104,0,2-0.896,2-2S74.637,54.024,73.532,54.024z M59.191,62.495H48.082c-4.411,0-8-3.589-8-8 V41.504c0-4.411,3.589-8,8-8h11.109V62.495z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharge);
export default __webpack_public_path__ + "static/media/charge.79c0253481cfe936dc0887b3cd96d63b.svg";
export { ForwardRef as ReactComponent };